import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/holiday/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
  request.get('/api/holiday/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
  request.post('/api/holiday/remove', qs.stringify(params), options);

export const add = (params, options) => request.post('/api/holiday/submit', params, options);

export const update = (params, options) => request.post('/api/holiday/update', params, options);

//新增表单数据
export const submitFormData = (params, options) => request.post('/api/holiday/saveData', params, options);
//获取分页表头数据
export const getTableStructure = (params, options) =>
  request.get('/api/holiday/list-structure', Object.assign({}, options, { params }));


